import {
  type BudgetDimension,
  type BudgetTree,
  type BudgetBranch,
  type BranchOf,
} from '../models/budgetTree';

export const getDimensionValues = (
  budgetTree: BudgetTree<unknown>,
  dimension: BudgetDimension,
): string[] => {
  const traverseBranch = (branch: BudgetBranch<unknown>): string[] => {
    return branch.nodes.flatMap((node) => {
      const values =
        branch.dimension === dimension && node.values ? node.values : [];
      return values.concat(node.branch ? traverseBranch(node.branch) : []);
    });
  };

  return traverseBranch(budgetTree.branch);
};

export const transformBudgetTreeOutcome = <InputOutcome, OutputOutcome>(
  tree: BudgetTree<InputOutcome>,
  transformOutcome: (outcome: InputOutcome) => OutputOutcome,
): BudgetTree<OutputOutcome> => {
  const traverseBranch = (
    branch: BranchOf<BudgetTree<InputOutcome>>,
  ): BranchOf<BudgetTree<OutputOutcome>> => ({
    ...branch,
    nodes: branch.nodes.map((node) => ({
      ...node,
      outcome: transformOutcome(node.outcome),
      branch: node.branch && traverseBranch(node.branch),
    })),
  });
  return {
    outcome: transformOutcome(tree.outcome),
    branch: traverseBranch(tree.branch),
  };
};
